interface ZoraIconProps {
  className?: string
  size?: number
}

// Zora's mark is a gradient orb — a monochrome disc is unrecognizable, so
// unlike the other chain icons there is no currentColor variant.
export const ZoraIcon: React.FC<ZoraIconProps> = ({ className, size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C7.02943 21 3 16.9706 3 11.9999C3 7.02943 7.02943 3 12 3C16.9706 3 20.9999 7.02943 20.9999 11.9999C20.9999 16.9706 16.9706 21 12 21Z"
        fill="url(#zora-orb)"
      />
      <defs>
        <radialGradient
          id="zora-orb"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0862 7.83953) rotate(180) scale(15.2029)"
        >
          <stop offset="0.00682297" stopColor="#F2CEFE" />
          <stop offset="0.1913" stopColor="#AFBAF1" />
          <stop offset="0.4982" stopColor="#4281D3" />
          <stop offset="0.666667" stopColor="#2E427D" />
          <stop offset="0.822917" stopColor="#230101" />
          <stop offset="1" stopColor="#8F6B40" />
        </radialGradient>
      </defs>
    </svg>
  )
}
